import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const STORAGE_KEY = "grabb_token";

export const getToken = () => {
  try { return localStorage.getItem(STORAGE_KEY) || null; } catch { return null; }
};
export const setToken = (t) => { if (t) localStorage.setItem(STORAGE_KEY, t); else localStorage.removeItem(STORAGE_KEY); };

export const api = axios.create({ baseURL: API_BASE });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Helpers — each returns response.data or throws.
const unwrap = (p) => p.then((r) => r.data);

export const apiAuth = {
  register: (body) => unwrap(api.post("/auth/register", body)),
  login: (body) => unwrap(api.post("/auth/login", body)),
  googleSession: (session_id) => unwrap(api.post("/auth/google/session", { session_id })),
  me: () => unwrap(api.get("/auth/me")),
  logout: () => unwrap(api.post("/auth/logout")),
};

export const apiUsers = {
  updateMe: (patch) => unwrap(api.patch("/users/me", patch)),
  get: (id) => unwrap(api.get(`/users/${id}`)),
};

export const apiInvites = {
  list: () => unwrap(api.get("/invites")),
  get: (id) => unwrap(api.get(`/invites/${id}`)),
  create: (body) => unwrap(api.post("/invites", body)),
  join: (id) => unwrap(api.post(`/invites/${id}/join`)),
  leave: (id) => unwrap(api.post(`/invites/${id}/leave`)),
  cancel: (id) => unwrap(api.delete(`/invites/${id}`)),
  checkin: (id) => unwrap(api.post(`/invites/${id}/checkin`)),
  noShow: (id, user_id) => unwrap(api.post(`/invites/${id}/no-show`, { user_id })),
  complete: (id) => unwrap(api.post(`/invites/${id}/complete`)),
};

export const apiChats = {
  list: () => unwrap(api.get("/chats")),
  messages: (chat_id) => unwrap(api.get(`/chats/${chat_id}/messages`)),
};

export const apiNotifications = {
  list: () => unwrap(api.get("/notifications")),
  readAll: () => unwrap(api.post("/notifications/read-all")),
};

export const apiTokens = {
  me: () => unwrap(api.get("/tokens")),
};

export const apiCrews = {
  list: () => unwrap(api.get("/crews")),
  get: (id) => unwrap(api.get(`/crews/${id}`)),
};

export const apiVenues = {
  list: () => unwrap(api.get("/venues")),
  get: (id) => unwrap(api.get(`/venues/${id}`)),
  create: (body) => unwrap(api.post("/venues", body)),
  scrape: (body) => unwrap(api.post("/venues/scrape", body)),
};

export const apiUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return unwrap(api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }));
};

// WebSocket URL helper
export const wsUrl = (chat_id) => {
  const wsBase = BACKEND_URL.replace(/^http/, "ws");
  const t = getToken();
  return `${wsBase}/api/ws/chat/${chat_id}${t ? `?token=${encodeURIComponent(t)}` : ""}`;
};
